import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ResultByAttempt from '@/components/features/result/ResultByAttempt/ResultByAttempt';
import Testing from '@/pages/testing/Testing';

interface ProdRoutesProps {
	children?: React.ReactNode;
}
const ProdRoutes: React.FC<ProdRoutesProps> = ({ children }) => {
	return (
		<Routes>
			<Route path='/a/:attemptKey' element={<ResultByAttempt />} />
			<Route path="/*" element={children ? children : <Testing />} />
		</Routes>
	);
};

export default ProdRoutes;
